// extracted by mini-css-extract-plugin
export var category = "_lf-9";
export var categoryHeader = "_lf-e";
export var container = "_lf-0";
export var group = "_lf-a";
export var groupItems = "_lf-f";
export var groupSeparator = "_lf-j";
export var loading = "_lf-1";
export var noResults = "_lf-3";
export var placeholder = "_lf-2";
export var resultContent = "_lf-5";
export var resultIcon = "_lf-c";
export var resultItem = "_lf-g";
export var resultMeta = "_lf-8";
export var resultSubtitle = "_lf-7";
export var resultSuffix = "_lf-i";
export var resultTitle = "_lf-6";
export var resultsList = "_lf-4";
export var searchGroup = "_lf-d";
export var selected = "_lf-h";
export var subgroup = "_lf-b";